import React from 'react';
import Typography from '@mui/material/Typography';

export default function Heading(props) {
  return (
    <Typography className={`Heading size-${props.size} weight-${props.weight} ${props.className}`} variant={props.variant}>
      {props.children}
    </Typography>
  );
}

Heading.defaultProps = {
  variant: 'h1',
  className: '',
  size: 'default',
  weight: 'default'
}